<template>
  <div class="detail-deposit-offexchange">
    <div class="content">
      <div class="wrap-left d-flex justify-content-between">
        <div>
          <div :style="{ marginBottom: '10px' }">
            <span>Transaction ID</span>
            <span class="content-data-status" :style="{ fontWeight: 'bold' }">{{
              dataDetail.transaction_id
            }}</span>
          </div>
          <div :style="{ marginBottom: '10px' }">
            <span>Owner</span>
            <span class="content-data-status" :style="{ fontWeight: 'bold' }">{{
              dataDetail.owner
            }}</span>
          </div>
          <div class="content-data content-data border-rounded">
            <div>
              <span>Deposit Date</span>
              <div class="content-data-status">
                <span>{{ dataDetail.deposit_date | formatDate }}</span>
              </div>
            </div>
            <div v-if="dataDetail.redeposit_date">
              <span>Re-Deposit Date</span>
              <span class="content-data-status">{{
                dataDetail.redeposit_date | formatDate
              }}</span>
            </div>
            <div>
              <span>Deposit Due Date</span>
              <div class="content-data-status">
                <span>{{ dataDetail.due_date | formatDate }}</span>
              </div>
            </div>
          </div>
          <div>
            <span>Weight (gr)</span>
            <span :style="{ fontWeight: 'bold' }" class="content-data-status">{{
              dataDetail.deposit_detail
                ? dataDetail.deposit_detail.actual_total_weight
                : ""
            }}</span>
          </div>
        </div>
        <div>
          <span class="content-data-status" :style="{ marginTop: '20px' }"
            >Status Deposit</span
          >
          <span
            v-show="dataDetail.status == '000'"
            class="vendor"
            :style="{ fontWeight: 'bold' }"
            >?</span
          >
          <span
            v-show="dataDetail.status == '001'"
            class="vendor"
            :style="{ fontWeight: 'bold' }"
            >New Submission</span
          >
          <span
            v-show="dataDetail.status == '002'"
            class="abx"
            :style="{ fontWeight: 'bold' }"
            >Approved By KMI</span
          >
          <span
            v-show="dataDetail.status == '003'"
            class="operator"
            :style="{ fontWeight: 'bold' }"
            >Waiting for Deposit</span
          >
          <span
            v-show="dataDetail.status == '004'"
            class="clearing"
            :style="{ fontWeight: 'bold' }"
            >Waiting for Test Result</span
          >
          <span v-show="dataDetail.status == '005'" class="stored">
            <span
              v-if="dataDetail.payment_info.payment_status == 'unpaid'"
              :style="{ fontWeight: 'bold' }"
              >Waiting for Payment</span
            >
            <span v-else>Stored</span>
          </span>
          <span
            v-show="dataDetail.status == '006'"
            class="reject"
            :style="{ fontWeight: 'bold' }"
            >Deposit Suspended</span
          >
          <span
            v-show="dataDetail.status == '007'"
            class="stored"
            :style="{ fontWeight: 'bold' }"
            >Waiting for Re-Deposit Confirmation</span
          >
          <span
            v-show="dataDetail.status == '008'"
            class="stored"
            :style="{ fontWeight: 'bold' }"
            >Waiting for KMI Confirmation</span
          >
          <span
            v-show="dataDetail.status == '009'"
            class="stored"
            :style="{ fontWeight: 'bold' }"
            >Reject</span
          >
        </div>
      </div>
      <div
        class="wrap-right"
        v-if="dataDetail.status == '003' || metalInfo.length != 0"
      >
        <div class="d-flex justify-content-between mb-3">
          <h5>Metal Detail</h5>
          <b-button
            variant="outline-primary"
            size="small"
            v-show="role == 5 && dataDetail.status == '003'"
            @click="openModal('modal-add_metal')"
            >Add Detail Metal</b-button
          >
        </div>
        <table class="table">
          <thead>
            <tr>
              <th>Serial Number</th>
              <th>Fineness</th>
              <th>Hallmark</th>
              <th>Denom (gr)</th>
              <th>Metal Type</th>
              <th>Print Date</th>
              <th>Year</th>
              <th>Status</th>
              <th
                v-if="
                  (dataDetail.status == '004' || dataDetail.status == '003') &&
                  (role == 2 || role == 5)
                "
              >
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(metal, i) in metalInfo" :key="i">
              <td>{{ metal.serial_number }}</td>
              <td>{{ metal.fineness }}</td>
              <td>{{ metal.hallmark }}</td>
              <td>{{ metal.weight }}</td>
              <td>
                <div v-if="metal.metal_type">
                  {{ metal.metal_type.type }} {{ metal.metal_type.bar }}
                </div>
                <div v-else>
                  {{ metal.metal ? metal.metal.type : "" }}
                  {{ metal.metal ? metal.metal.form : "" }}
                </div>
              </td>
              <td>{{ metal.print_date | formatDate }}</td>
              <td>{{ metal.year }}</td>
              <td>
                <span v-show="metal.status == '001'" class="vendor"
                  >Submited</span
                >
                <span v-show="metal.status == '002'" class="abx">Approved</span>
                <span v-show="metal.status == '003'" class="operator"
                  >Rejected</span
                >
                <span v-show="metal.status == '004'" class="clearing"
                  >Stored</span
                >
                <span v-show="metal.status == '005'" class="stored"
                  >Process</span
                >
                <span v-show="metal.status == '006'" class="reject"
                  >Withdrawan</span
                >
                <span v-show="metal.status == '007'" class="stored"
                  >Unsued</span
                >
              </td>
              <td v-if="dataDetail.status == '004' && role == 2">
                <div style="font-size: 1.3rem">
                  <b-icon
                    icon="check-square"
                    variant="success"
                    class="btn-icon mr-1"
                    @click="openModal('modal-approve_metal', '', metal)"
                    v-if="metal.status == '001'"
                  ></b-icon>
                  <b-icon
                    icon="pencil-square"
                    class="mx-1 btn-icon"
                    v-if="metal.status != '003'"
                    variant="info"
                    @click="openModalEdit('modal-edit_metal', metal)"
                  ></b-icon>
                  <b-icon
                    icon="x-circle"
                    variant="danger"
                    class="btn-icon"
                    @click="openModal('modal-reject_metal', '', metal)"
                    v-if="metal.status == '001'"
                  ></b-icon>
                </div>
              </td>
              <td
                v-else-if="
                  dataDetail.status == '003' && role == 5 && !metal.status
                "
              >
                <div style="font-size: 1.3rem">
                  <b-icon
                    icon="pencil-square"
                    class="mx-1 btn-icon"
                    variant="info"
                    @click="openModalEdit('modal-edit_metal', metal, i)"
                  ></b-icon>
                  <b-icon
                    icon="trash"
                    class="btn-icon"
                    variant="danger"
                    @click="deleteMetal(i)"
                  ></b-icon>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="wrap-right attachment">
        <div class="nav-tab">
          <img src="@/assets/icon_tab.svg" />
          <span
            class="tab"
            :class="{ activeTab: typePage == 'attachment' }"
            @click="filterTypeDeposit('attachment')"
            >Attachment</span
          >
          <img src="@/assets/icon_tab.svg" />
          <span
            class="tab"
            :class="{ activeTab: typePage == 'history' }"
            @click="filterTypeDeposit('history')"
            >History</span
          >
        </div>

        <div v-if="this.typePage == 'attachment'">
          <div class="line"></div>
          <div class="content-data-attachment">
            <div>
              <span>Application Letter</span>
              <img
                v-show="
                  dataDetail.attachments.application_doc != null ||
                  dataDetail.attachments.application_doc != undefined
                "
                class="icon"
                src="@/assets/icon-check-circle.png"
              />
            </div>
            <button
              type="button"
              class="btn btn-sm"
              v-if="dataDetail.attachments.application_doc"
              @click="
                openPreview(
                  dataDetail.attachments.application_doc,
                  'Application Letter'
                )
              "
            >
              View
              <img
                src="@/assets/Icon Right.png"
                alt="Eye Icon"
                style="margin-left: 5px"
              />
            </button>
            <span class="text-attachment" v-else
              >The file has not been added</span
            >
          </div>
          <div class="line"></div>
          <div class="content-data-attachment">
            <div>
              <span>Assignment Letter</span>
              <img
                v-show="
                  dataDetail.attachments.assessment_doc != null ||
                  dataDetail.attachments.assessment_doc != undefined
                "
                class="icon"
                src="@/assets/icon-check-circle.png"
              />
            </div>
            <button
              type="button"
              class="btn btn-sm"
              v-if="dataDetail.attachments.assessment_doc"
              @click="
                openPreview(
                  dataDetail.attachments.assessment_doc,
                  'Assignment Letter'
                )
              "
            >
              View
              <img
                src="@/assets/Icon Right.png"
                alt="Eye Icon"
                style="margin-left: 5px"
              />
            </button>
            <span class="text-attachment" v-else
              >The file has not been added</span
            >
          </div>
          <div class="line"></div>
          <div class="content-data-attachment">
            <div>
              <span>Deposit Report</span>
              <img
                v-show="filteredDepositDocuments.length != 0"
                class="icon"
                src="@/assets/icon-check-circle.png"
              />
            </div>
            <div
              v-if="
                (dataDetail.status == '004' || dataDetail.status == '008') &&
                role == 2
              "
              class="container-value-document"
            >
              <ul v-if="filteredDepositDocuments.length != 0">
                <span
                  v-for="(docDeposit, i) in filteredDepositDocuments"
                  :key="i"
                >
                  <button
                    type="button"
                    class="btn btn-sm"
                    @click="openPreview(docDeposit.url, 'KMI Report')"
                  >
                    View
                    <img
                      src="@/assets/Icon Right.png"
                      alt="Eye Icon"
                      style="margin-left: 5px"
                    />
                  </button>
                </span>
              </ul>
              <div v-if="filteredDepositDocuments.length != 0">
                <span
                  @click="openModal('modal-add_doc', 'kmi')"
                  class="upload-text cursor"
                  >Update Deposit Report</span
                >
                <img class="icon" src="@/assets/Icon Right Upload.png" />
              </div>
              <div v-else>
                <span
                  @click="openModal('modal-add_doc', 'kmi')"
                  class="upload-text cursor"
                  >Add Deposit Report</span
                >
                <img class="icon" src="@/assets/Icon Right Upload.png" />
              </div>
            </div>
            <div v-else>
              <ul v-if="filteredDepositDocuments.length != 0">
                <span
                  v-for="(docDeposit, i) in filteredDepositDocuments"
                  :key="i"
                >
                  <button
                    type="button"
                    class="btn btn-sm"
                    @click="openPreview(docDeposit.url, 'KMI Report')"
                  >
                    View
                    <img
                      src="@/assets/Icon Right.png"
                      alt="Eye Icon"
                      style="margin-left: 5px"
                    />
                  </button>
                </span>
              </ul>
              <span class="text-attachment" v-else
                >The file has not been added</span
              >
            </div>
          </div>
          <div class="line"></div>
          <div class="content-data-attachment">
            <div>
              <span>Analysis Report</span>
              <img
                v-show="filteredAnalysisDocuments.length != 0"
                class="icon"
                src="@/assets/icon-check-circle.png"
              />
            </div>
            <div
              v-if="
                (dataDetail.status == '004' || dataDetail.status == '008') &&
                role == 2
              "
              class="container-value-document"
            >
              <ul v-if="filteredAnalysisDocuments.length != 0">
                <span v-for="(docKmi, i) in filteredAnalysisDocuments" :key="i">
                  <button
                    type="button"
                    class="btn btn-sm"
                    @click="openPreview(docKmi.url, 'Pegadaian Report')"
                  >
                    View
                    <img
                      src="@/assets/Icon Right.png"
                      alt="Eye Icon"
                      style="margin-left: 5px"
                    />
                  </button>
                </span>
              </ul>

              <div v-if="filteredAnalysisDocuments.length != 0">
                <span
                  @click="openModal('modal-add_doc', 'analysis')"
                  class="upload-text cursor"
                  >Update Analysis Report</span
                >
                <img class="icon" src="@/assets/Icon Right Upload.png" />
              </div>

              <div v-else>
                <span
                  @click="openModal('modal-add_doc', 'analysis')"
                  class="upload-text cursor"
                  >Add Analysis Report</span
                >
                <img class="icon" src="@/assets/Icon Right Upload.png" />
              </div>
            </div>
            <div v-else>
              <ul v-if="filteredAnalysisDocuments.length != 0">
                <span v-for="(docKmi, i) in filteredAnalysisDocuments" :key="i">
                  <button
                    type="button"
                    class="btn btn-sm"
                    @click="openPreview(docKmi.url, 'Pegadaian Report')"
                  >
                    View
                    <img
                      src="@/assets/Icon Right.png"
                      alt="Eye Icon"
                      style="margin-left: 5px"
                    />
                  </button>
                </span>
              </ul>
              <span class="text-attachment" v-else
                >The file has not been added</span
              >
            </div>
          </div>
          <!-- <div class="content-data" v-if="dataDetail.redeposit_date">
            <span>Analysis Report</span>
            <span>{{ dataDetail.redeposit_date | formatDate }}</span>
          </div> -->
          <div class="line"></div>
          <div class="content-data-attachment">
            <div>
              <span>Invoice</span>
              <img
                v-show="dataDetail.attachments.invoice_doc"
                class="icon"
                src="@/assets/icon-check-circle.png"
              />
            </div>
            <button
              type="button"
              class="btn btn-sm"
              v-if="dataDetail.attachments.invoice_doc"
              @click="
                openPreview(dataDetail.attachments.invoice_doc, 'Invoice')
              "
            >
              View
              <img
                src="@/assets/Icon Right.png"
                alt="Eye Icon"
                style="margin-left: 5px"
              />
            </button>
            <div v-else>
              <div
                v-if="
                  dataDetail.payment_info.payment_status == 'unpaid' &&
                  dataDetail.status == '005' &&
                  role == 2
                "
              >
                <span
                  @click="openModal('modal-add_doc', 'invoice')"
                  class="upload-text cursor"
                  >Add Invoice</span
                >
                <img class="icon" src="@/assets/Icon Right Upload.png" />
              </div>
              <span class="text-attachment" v-else
                >The file has not been added</span
              >
            </div>
          </div>
          <div class="line"></div>
          <div class="content-data-attachment">
            <div>
              <span>Proof Payment</span>
              <img
                v-show="dataDetail.attachments.receipt_doc"
                class="icon"
                src="@/assets/icon-check-circle.png"
              />
            </div>
            <button
              type="button"
              class="btn btn-sm"
              v-if="dataDetail.attachments.receipt_doc"
              @click="
                openPreview(dataDetail.attachments.receipt_doc, 'Proof Payment')
              "
            >
              View
              <img
                src="@/assets/Icon Right.png"
                alt="Eye Icon"
                style="margin-left: 5px"
              />
            </button>
            <span class="text-attachment" v-else
              >The file has not been added by KBI</span
            >
          </div>
          <div class="line"></div>
          <div class="content-data-attachment">
            <div>
              <span>Deposit Confirmation</span>
              <img
                v-show="dataDetail.attachments.deposit_evidence_doc"
                class="icon"
                src="@/assets/icon-check-circle.png"
              />
            </div>
            <button
              type="button"
              class="btn btn-sm"
              v-if="dataDetail.attachments.deposit_evidence_doc"
              @click="
                openPreview(
                  dataDetail.attachments.deposit_evidence_doc,
                  'Deposit Confirmation'
                )
              "
            >
              View
              <img
                src="@/assets/Icon Right.png"
                alt="Eye Icon"
                style="margin-left: 5px"
              />
            </button>
            <div v-else>
              <div
                v-if="
                  dataDetail.payment_info.payment_status == 'paid' &&
                  dataDetail.status == '005' &&
                  dataDetail.attachments.deposit_evidence_doc == '' &&
                  role == 2
                "
              >
                <span
                  @click="openModal('modal-add_doc', 'evidence')"
                  class="upload-text cursor"
                  >Add Deposit Confirmation</span
                >
                <img class="icon" src="@/assets/Icon Right Upload.png" />
              </div>
              <span class="text-attachment" v-else
                >The file has not been added</span
              >
            </div>
          </div>
          <div class="line"></div>
        </div>

        <div v-else>
          <div>
            <div
              v-for="(section, index) in sections"
              :key="index"
              class="section"
            >
              <div
                class="section-header content-data-attachment"
                @click="toggleSection(index)"
              >
                {{ section.title }}
                <img v-if="section.open" src="@/assets/Shape (3).png" />
                <img v-else src="@/assets/Shape (2).png" />
              </div>
              <div v-if="section.open" class="section-content">
                <div v-if="Array.isArray(section.documents)">
                  <div
                    v-for="(document, docIndex) in section.documents"
                    :key="docIndex"
                  >
                    <div
                      :style="{ marginTop: '10px' }"
                      class="content-data-attachment"
                    >
                      <span
                        class="text-link"
                        @click="openPreview(document.url, sections.title)"
                        >{{
                          section.title + " (" + (docIndex + 1) + ")"
                        }}
                        .pdf</span
                      >
                      <span>{{ formatDate(document.date) }}</span>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div
                    :style="{ marginTop: '10px' }"
                    class="content-data-attachment"
                  >
                    <span
                      v-show="section.documents"
                      class="text-link"
                      @click="openPreview(section.documents, sections.title)"
                      >{{ section.title }} .pdf</span
                    >
                    <span v-show="section.date">{{
                      formatDate(section.date)
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal ref="modal-add_metal" hide-footer title="Add Detail Metal">
        <form action="">
          <div class="form-group">
            <label for="">Metal Type</label>
            <input
              type="text"
              name=""
              id=""
              v-model="metal_type.type"
              readonly
              class="form-input metal-type-style mr-3"
            />
            <select
              name=""
              id=""
              v-model="metal_type.bar"
              class="form-input metal-type-style"
            >
              <option value="" selected disabled>Select Metal Bar</option>
              <option value="mint">Mint</option>
              <option value="cast">Cast</option>
            </select>
            <div v-if="$v.metal_type.bar.$error">
              <div class="form-error" v-if="!$v.metal_type.bar.required">
                Metal Type is Required
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="">Print Date</label>
            <input
              type="date"
              v-model="form.print_date"
              class="form-input"
              :max="today"
            />
            <div v-if="$v.form.print_date.$error">
              <div class="form-error" v-if="!$v.form.print_date.required">
                Print Date is Required
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="">Fineness</label>
            <input
              type="text"
              v-model="form.fineness"
              placeholder="99%"
              class="form-input"
            />
            <div v-if="$v.form.fineness.$error">
              <div class="form-error" v-if="!$v.form.fineness.required">
                Finennes is Required
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="">Hallmark</label>
            <input
              type="text"
              v-model="form.hallmark"
              placeholder="gold merk"
              class="form-input"
            />
            <div v-if="$v.form.hallmark.$error">
              <div class="form-error" v-if="!$v.form.hallmark.required">
                Hallmark is Required
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="">Weight(gr)</label>
            <input
              type="text"
              v-model="form.weight"
              placeholder="1.000"
              class="form-input"
            />
            <div v-if="$v.form.hallmark.$error">
              <div class="form-error" v-if="!$v.form.hallmark.required">
                Weight is Required
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="">Serial Number</label>
            <input
              type="text"
              v-model="form.serial_number"
              placeholder="MTLGxxxxx"
              class="form-input"
            />
            <div v-if="$v.form.serial_number.$error">
              <div class="form-error" v-if="!$v.form.serial_number.required">
                Serial Number is Required
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="">Year</label>
            <input type="text" v-model="form.year" class="form-input" />
            <div v-if="$v.form.year.$error">
              <div class="form-error" v-if="!$v.form.year.required">
                Year is Required
              </div>
            </div>
          </div>
        </form>
        <div class="text-right">
          <b-button class="mt-3" variant="primary" @click="addMetal">
            Add Metal
          </b-button>
        </div>
      </b-modal>
      <b-modal ref="modal-edit_metal" hide-footer title="Edit Detail Metal">
        <form action="">
          <div class="form-group">
            <label for="">Metal Type</label>
            <input
              type="text"
              name=""
              id=""
              v-model="metal_type.type"
              readonly
              class="form-input metal-type-style mr-3"
            />
            <select
              name=""
              id=""
              v-model="metal_type.bar"
              class="form-input metal-type-style"
            >
              <option value="" selected disabled>Select Metal Bar</option>
              <option value="mint">Mint</option>
              <option value="cast">Cast</option>
            </select>
          </div>
          <div class="form-group">
            <label for="">Print Date</label>
            <input type="date" v-model="form.print_date" class="form-input" />
          </div>
          <div class="form-group">
            <label for="">Fineness</label>
            <input
              type="text"
              v-model="form.fineness"
              placeholder="99%"
              class="form-input"
            />
          </div>
          <div class="form-group">
            <label for="">Hallmark</label>
            <input
              type="text"
              v-model="form.hallmark"
              placeholder="gold merk"
              class="form-input"
            />
          </div>
          <div class="form-group">
            <label for="">Weight (gr)</label>
            <input
              type="text"
              v-model="form.weight"
              placeholder="1.000"
              class="form-input"
            />
          </div>
          <div class="form-group">
            <label for="">Serial Number</label>
            <input
              type="text"
              v-model="form.serial_number"
              placeholder="MTLGxxxxx"
              class="form-input"
            />
          </div>
          <div class="form-group">
            <label for="">Year</label>
            <input type="text" v-model="form.year" class="form-input" />
          </div>
        </form>
        <div class="text-right">
          <b-button
            v-if="dataDetail.status == '003' && role == 5"
            class="mt-3"
            variant="primary"
            @click="editLocalDataMetal()"
          >
            Edit Metal
          </b-button>
          <b-button v-else class="mt-3" variant="primary" @click="editMetal">
            Edit Metal
          </b-button>
        </div>
      </b-modal>
      <b-modal ref="modal-add_doc" title="Upload Document" hide-footer>
        <form action="">
          <div class="form-group">
            <label for="customs-doc" class="label-form">
              Upload Document
              <b class="upperCase">
                <span v-if="typeDoc == 'evidence'"> Deposit Confirmation </span>
                <span v-else-if="typeDoc == 'receipt'"> Proof Payment</span>
                <span v-else>{{ typeDoc }}</span>
              </b>
            </label>
            <label class="upload-video text-center">
              <span v-if="!isLoadDataCustomDoc">
                <b-icon icon="upload" class="mr-1 icon-upload"></b-icon> Choose
                File
              </span>
              <b-spinner small variant="ligth" v-else></b-spinner>
              <input
                type="file"
                accept="image/*, application/pdf"
                ref="customsDoc"
                @change="onCustomDoc"
              />
            </label>
            <span id="imageName" class="ml-3"> {{ label_custom }}</span>
          </div>
          <div class="text-right mt-3">
            <b-button variant="primary" @click="setUpDocument">
              <b-spinner v-if="isLoadAddDoc" small></b-spinner>
              <span v-else>Add Document </span>
            </b-button>
          </div>
        </form>
      </b-modal>
      <b-modal ref="preview-modal" size="lg" :title="labelPreview">
        <div class="d-block text-center">
          <div v-if="isPdf">
            <b-spinner label="Loading..." v-if="isLoadingPreview"></b-spinner>
            <pdf v-for="i in numPages" :key="i" :src="src" :page="i" v-else />
          </div>
          <div v-else>
            <b-spinner label="Loading..." v-if="isLoadingPreview"></b-spinner>
            <img
              :src="src"
              alt=""
              style="width: 100%; object-fit: cover"
              v-else
            />
          </div>
        </div>
      </b-modal>
      <b-modal ref="modal-approve_metal" title="Confirm Metal" hide-footer>
        <div class="text-center">Are sure to Approve this metal?</div>
        <div class="text-right mt-5">
          <b-button
            variant="light mr-3"
            @click="hideModal('modal-approve_metal')"
          >
            Cancel
          </b-button>
          <b-button variant="primary" @click="updateMetal('002')">
            <b-spinner v-if="isLoadUpdateMetal" small></b-spinner>
            <span v-else>Approve Metal</span>
          </b-button>
        </div>
      </b-modal>
      <b-modal ref="modal-reject_metal" title="Reject Metal" hide-footer>
        <div class="text-center">Are sure to <b>Reject</b> this metal?</div>
        <div class="text-right mt-5">
          <b-button
            variant="danger mr-3"
            @click="hideModal('modal-reject_metal')"
          >
            Cancel
          </b-button>
          <b-button variant="light" @click="updateMetal('003')">
            <b-spinner v-if="isLoadUpdateMetal" small></b-spinner>
            <span v-else>Reject Metal</span>
          </b-button>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import pdf from "vue-pdf";
import moment from "moment";
import { required } from "vuelidate/lib/validators";

export default {
  components: { pdf },
  props: {
    dataDetail: Object,
  },
  data() {
    return {
      sections: [
        {
          title: "Application Letter",
          document: null,
          fileName: "Application Letter File Name.pdf",
          open: false,
          date: "",
        },
        {
          title: "Assignment Letter",
          documents: null,
          open: false,
          date: "",
        },
        {
          title: "Deposit Report",
          documents: [],
          open: false,
          date: "",
        },
        {
          title: "Analysis Report",
          documents: [],
          open: false,
          date: "",
        },
        {
          title: "Invoice",
          documents: [],
          open: false,
          date: "",
        },
        {
          title: "Proof of Payment",
          documents: [],
          open: false,
          date: "",
        },
        {
          title: "Deposit Confirmation",
          documents: [],
          open: false,
          date: "",
        },
      ],

      labelPreview: "",
      isLoadDataCustomDoc: false,

      typePage: "attachment",

      indexLocalEdit: 0,

      label_custom: "",
      isPdf: false,
      isLoadingPreview: false,
      isLoadUpdateMetal: false,
      isLoadAddDoc: false,
      metals: [],
      numPages: undefined,
      src: null,
      getDetail: [],
      role: sessionStorage.getItem("role"),
      metal_type: {
        type: "gold",
        bar: "",
      },
      form: {
        fineness: "",
        hallmark: "",
        weight: Number(),
        serial_number: "",
        year: "",
        print_date: "",
      },
      documentMetal: "",
      typeDoc: "",
      lengthMetal: "",
      dataUpdateMetal: "",
      today: "",
    };
  },
  validations: {
    form: {
      fineness: {
        required,
      },
      hallmark: {
        required,
      },
      weight: {
        required,
      },
      serial_number: {
        required,
      },
      year: {
        required,
      },
      print_date: {
        required,
      },
    },
    metal_type: {
      bar: { required },
    },
  },
  mounted() {
    this.initializeSections();
    this.today = new Date().toISOString().split("T")[0];
    let dataMetals = JSON.parse(sessionStorage.getItem("metalAdd"));
    if (dataMetals) {
      this.metals = dataMetals;
    }
  },
  computed: {
    metalInfo() {
      let data = this.dataDetail.metal_info;
      if (data.length == 0) {
        data = this.metals;
      } else {
        data = data.concat(this.metals);
      }
      return data;
    },

    filteredAnalysisDocuments() {
      return this.getFilteredDocuments("analysis_doc");
    },
    filteredDepositDocuments() {
      return this.getFilteredDocuments("deposit_doc");
    },
  },
  beforeDestroy() {
    sessionStorage.removeItem("metalAdd");
  },
  methods: {
    filterTypeDeposit(value) {
      this.typePage = value;
    },
    toggleSection(index) {
      this.sections[index].open = !this.sections[index].open;
    },
    formatDate(dateString) {
      const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      };
      return new Date(dateString).toLocaleDateString(undefined, options);
    },

    initializeSections() {
      this.sections[0].documents = this.dataDetail.attachments.application_doc;
      this.sections[1].documents = this.dataDetail.attachments.assessment_doc;
      this.sections[2].documents =
        this.dataDetail.attachments.event_report_doc.deposit_doc;
      this.sections[3].documents =
        this.dataDetail.attachments.event_report_doc.analysis_doc;
      this.sections[4].documents = this.dataDetail.attachments.invoice_doc;
      this.sections[5].documents = this.dataDetail.attachments.receipt_doc;
      this.sections[6].documents =
        this.dataDetail.attachments.deposit_evidence_doc;
      this.sections[0].date = this.dataDetail.deposit_date;
      this.sections[1].date = this.dataDetail.deposit_date;
    },
    getFilteredDocuments(docType) {
      let docs = this.dataDetail.attachments.event_report_doc[docType] || [];
      let activeDocs = docs.filter((doc) => doc.isActive);
      activeDocs.sort((a, b) => new Date(b.date) - new Date(a.date));
      return activeDocs.length > 0 ? [activeDocs[0]] : [];
    },
    getFileNameFromUrl(url) {
      const parts = url.split("/");
      const fileName = parts[parts.length - 1];
      return fileName;
    },
    async downloadPDF(doc) {
      let base_url = axios.defaults.baseURL;
      const sig_url =
        base_url +
        "/v2/vms/withdrawal/pdf/" +
        this.clientID +
        "/" +
        this.getFileNameFromUrl(doc);
      console.log(sig_url);
      const token = sessionStorage.getItem("token");

      const response = await fetch(sig_url, {
        method: "GET",
        headers: {
          authorization: "Bearer " + token,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch PDF");
      }

      const arrayBuffer = await response.arrayBuffer();
      const blob = new Blob([arrayBuffer], { type: "application/pdf" });

      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      let fileName =
        "request-letter - " + this.getFileNameFromUrl(response.url);
      link.download = fileName;
      link.click();
    },
    onCustomDoc() {
      this.isLoadDataCustomDoc = true;
      this.label_custom = "";
      const fileCustomDoc = this.$refs.customsDoc.files[0];
      if (
        fileCustomDoc.type == "image/jpeg" ||
        fileCustomDoc.type == "image/jpg" ||
        fileCustomDoc.type == "image/png" ||
        fileCustomDoc.type == "application/pdf"
      ) {
        this.requestFormData(fileCustomDoc).then((res) => {
          this.isLoadDataCustomDoc = false;
          this.label_custom = fileCustomDoc.name;
          this.documentMetal = res.data.data;
        });
      }
    },
    requestFormData(fileData) {
      let formData = new FormData();
      formData.append("file", fileData);
      formData.append("type", "deposit");
      formData.append("trx_id", this.dataDetail.client.id);
      return axios.post("/v2/upload/external", formData);
    },
    setUpDocument() {
      this.isLoadAddDoc = true;
      let dataDoc = {
        _id: this.$route.params.id,
        doc_type: this.typeDoc,
        doc_url: this.documentMetal,
      };
      console.log("data document => " + JSON.stringify(dataDoc));

      axios
        .put("/v2/clearing/admin/abx/offexchange/deposit/update_doc", dataDoc)
        .then((res) => {
          if (!res.data.iserror) {
            this.$toast.success("Add Document Success");
            this.$refs["modal-add_doc"].hide();
            location.reload();
          }
        })
        .catch((err) => {
          console.log(err.response);
          this.$toast.error("Somthing when wrong");
          this.isLoadAddDoc = false;
        });
    },
    openPreview(file, label) {
      this.$refs["preview-modal"].show();
      this.labelPreview =
        label == "Pegadaian Report"
          ? "Analysis Report"
          : label == "KMI Report"
          ? "Deposit Report"
          : label;
      this.isLoadingPreview = true;
      let newFile = file.replace("/kmi", "/vms");
      this.getImage(newFile)
        .then((res) => {
          if (file.split(".").pop() == "pdf") {
            this.isPdf = true;
            this.isLoadingPreview = false;
            this.src = pdf.createLoadingTask(res);
            this.src.promise.then((pdf) => {
              this.numPages = pdf.numPages;
            });
          } else {
            this.isLoadingPreview = false;
            this.isPdf = false;
            this.src = res;
          }
        })
        .catch(() => {
          this.isLoadingPreview = false;
        });
    },
    async getImage(file) {
      let image = await axios.get("/v2" + file, { responseType: "blob" });
      image = URL.createObjectURL(
        new Blob([image.data], { type: image.data.type })
      );
      return image;
    },
    openModal(refModal, type_doc, dataMetal) {
      this.typeDoc = type_doc;
      this.$refs[refModal].show();
      this.dataUpdateMetal = dataMetal;
      this.metal_type = {
        type: "gold",
        bar: "",
      };
      this.form = {
        fineness: "",
        hallmark: "",
        weight: "",
        serial_number: "",
        year: "",
        print_date: "",
      };
    },
    openModalEdit(refModal, dataMetal, index) {
      this.indexLocalEdit = index;
      this.form = {
        fineness: dataMetal.fineness,
        hallmark: dataMetal.hallmark,
        weight: dataMetal.weight,
        serial_number: dataMetal.serial_number,
        year: dataMetal.year,
        print_date: moment(dataMetal.print_date).format("YYYY-MM-DD"),
      };
      this.$refs[refModal].show();
      this.dataUpdateMetal = dataMetal;
      this.metal_type = {
        type: "gold",
        bar: dataMetal.metal.form,
      };
    },
    hideModal(refModal) {
      this.$refs[refModal].hide();
    },
    editMetal() {
      this.isLoadUpdateMetal = true;
      let dataMetal = {
        _id: this.$route.params.id,
        metal: {
          metal_id: this.dataUpdateMetal.metal_id,
          metal_type: { ...this.metal_type },
          ...this.form,
          status: this.dataUpdateMetal.status,
        },
      };
      axios
        .put(
          "/v2/clearing/admin/abx/offexchange/deposit/update_metal",
          dataMetal
        )
        .then((res) => {
          if (!res.data.iserror) {
            this.isLoadUpdateMetal = false;
            this.$toast.success("Edit Metal Success");
            location.reload();
          }
        });
    },
    editLocalDataMetal() {
      if (
        this.indexLocalEdit !== -1 &&
        this.indexLocalEdit < this.metalInfo.length
      ) {
        let data = { metal_type: { ...this.metal_type }, ...this.form };
        this.$set(this.metalInfo, this.indexLocalEdit, Object.assign({}, data));
        sessionStorage.setItem("metalAdd", JSON.stringify(this.metalInfo));
        this.$toast.success("Edit Metal Success");
        this.$refs["modal-edit_metal"].hide();
      } else {
        this.$toast.error("Index tidak valid");
      }
    },
    deleteMetal(index) {
      this.metals.splice(index, 1);
      sessionStorage.setItem("metalAdd", JSON.stringify(this.metals));
      this.$toast.success("Delete Metal successfully !!");
    },
    addMetal() {
      this.$v.form.$touch();
      this.$v.metal_type.$touch();
      if (this.$v.metal_type.$error) {
        console.log("metal type error");
        return;
      }
      if (this.$v.form.$error) {
        return;
      }
      let totalWeight = 0;
      for (let i = 0; i < this.metalInfo.length; i++) {
        if (this.metalInfo[i].status == "002" || !this.metalInfo[i].status) {
          totalWeight += this.metalInfo[i].weight;
        }
      }
      let result = 0;
      result = parseInt(totalWeight) + parseInt(this.form.weight);
      if (result > this.dataDetail.deposit_detail.actual_total_weight) {
        this.$toast.error("Metal exceeds the total weight");
      } else {
        console.log("bisa proses:", totalWeight);
        let data;
        this.form.weight = parseInt(this.form.weight);
        data = { metal_type: { ...this.metal_type }, ...this.form };
        this.metals.push(data);
        sessionStorage.setItem("metalAdd", JSON.stringify(this.metals));
        this.$refs["modal-add_metal"].hide();
      }
    },
    updateMetal(status) {
      this.isLoadUpdateMetal = true;
      this.dataUpdateMetal.print_date = moment(
        this.dataUpdateMetal.print_date
      ).format("YYYY/MM/DD");
      let dataMetal = {
        _id: this.$route.params.id,
        metal: {
          metal_id: this.dataUpdateMetal.metal_id,
          metal_type: {
            type: this.dataUpdateMetal.metal.type,
            bar: this.dataUpdateMetal.metal.form,
          },
          fineness: this.dataUpdateMetal.fineness,
          hallmark: this.dataUpdateMetal.hallmark,
          weight: this.dataUpdateMetal.weight,
          serial_number: this.dataUpdateMetal.serial_number,
          year: this.dataUpdateMetal.year,
          print_date: this.dataUpdateMetal.print_date,
          status: status,
        },
      };
      let responseMsg;
      if (status == "003") {
        responseMsg = "Metal has been Reject";
      } else if (status == "002") {
        responseMsg = "Metal has been Approved";
      }
      axios
        .put(
          "/v2/clearing/admin/abx/offexchange/deposit/update_metal",
          dataMetal
        )
        .then((res) => {
          if (!res.data.iserror) {
            this.$toast.success(responseMsg);
            location.reload();
          }
        })
        .catch((err) => {
          this.isLoadUpdateMetal = false;
          let status = err.response.data.data.status_code;
          let errMsg;
          if (status == "1009") {
            errMsg = "Please input document first";
          } else {
            errMsg = err.response.data.data.err_message;
          }
          this.$toast.error(errMsg);
        });
    },
  },
};
</script>

<style scoped>
.wrap-left,
.wrap-right {
  box-shadow: 0px 0px 10px 0px rgb(0 0 0 / 11%);
  padding: 1.5rem;
  border-radius: 5px;
  margin-bottom: 2rem;
}

.content-data {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}

.content-data-status {
  display: flex;
  gap: 1rem;
}

.content-data-attachment {
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  align-items: center;
  padding-left: 10px;
  padding-right: 10px;
}

.container-value-document {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.content-data span:first-child {
  width: 8rem;
  font-size: 14px;
}

.content-data span:last-child {
  font-weight: bold;
}

.btn-primer {
  background: var(--clr-scondary);
  border: none;
  color: #ffffff;
  padding: 5px 25px;
  border-radius: 5px;
}

.btn-primer:hover {
  background-color: var(--clr-scondary-hover);
}

.form-group label {
  width: 30%;
}

.form-input {
  width: 70%;
}

.metal-type-style {
  width: 33%;
}

.label-form {
  display: block;
  width: 100% !important;
  font-weight: bold;
}

.upperCase {
  text-transform: uppercase;
}

.upload-video {
  border: 1px solid #1f354a;
  padding: 0.5rem;
  color: #1f354a;
  border-radius: 5px;
  font-size: 12px;
  cursor: pointer;
  font-weight: bold;
}

.upload-video:hover {
  background: #1f354a;
  color: #ffffff;
}

.icon-upload {
  font-size: 13px;
}

#inputTag {
  display: none;
}

input[type="file"] {
  display: none;
}

.btn-icon {
  cursor: pointer;
}
ul {
  margin-bottom: unset;
}

ul li {
  list-style: inside;
}

.nav-tab {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 2rem;
  color: #636366;
  padding: 0.8rem 0;
  justify-self: flex-start;
}

.tab {
  padding: 0.8rem 1rem;
  cursor: pointer;
}

.tab:hover,
.activeTab {
  color: var(--clr-scondary);
  border-bottom: 2px solid var(--clr-scondary);
}

.line {
  height: 1px;
  background-color: #ccc;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
}

.text-attachment {
  padding-top: 5px;
  padding-bottom: 5px;
}

.icon {
  padding: 8px;
}

.cursor {
  cursor: pointer;
}

.upload-text {
  color: rgb(28, 155, 209);
  font-weight: 500;
}

.border-rounded {
  border: 1px solid rgb(165, 164, 164);
  border-radius: 5px;
  padding: 10px;
}
.container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}
.section {
  margin-bottom: 20px;
}
.section-header {
  font-weight: bold;
  padding: 15px;
  background-color: #eaeaea;
  cursor: pointer;
}
.section-content {
  padding: 10px;
  border: 1px solid #ddd;
  border-top: none;
}
.document {
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
}
.document a {
  color: #1a73e8;
  text-decoration: none;
}
.document span {
  color: #888;
}

.text-link {
  color: #1a73e8;
  text-decoration: none;
  cursor: pointer;
}
</style>
